import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Button, Typography } from 'wtb-components';
import { useAppContext, useDialogNavigationContext, useLocaleContext, useTransactionContext } from 'context';
import { ANALYTICS_EVENTS, ERROR_TYPES } from 'constants.js';
import { ContactMessage } from 'components';
import { useSendAnalyticsEvent } from 'hooks';
import { ReactComponent as ErrorAnimation } from 'assets/animations/error/error.svg';
import { ReactComponent as InternetError } from 'assets/images/nointernet.svg';
import { ReactComponent as ExpiredError } from 'assets/images/expired.svg';
import styles from '../Finish.module.css';

const getTranslationKeyTitles = (errorType, type = 'title') => {
  switch (errorType) {
    case ERROR_TYPES.NO_INTERNET:
      return `finish.error.noInternet.${type}`;
    case ERROR_TYPES.EXPIRED:
      return `finish.error.expired.${type}`;
    default:
      return `finish.error.${type}`;
  }
};

const getErrorAnimation = (errorType) => {
  switch (errorType) {
    case ERROR_TYPES.NO_INTERNET:
      return InternetError;
    case ERROR_TYPES.EXPIRED:
      return ExpiredError;
    default:
      return ErrorAnimation;
  }
};

const Error = () => {

  const { id } = useParams();

  const {
    setHasFooter
  } = useDialogNavigationContext();
  const { merchant: { name, redirect } } = useTransactionContext();
  const { translate } = useLocaleContext();
  const {
    appErrorType,
    errorRedirectUrl
  } = useAppContext();

  const sendAnalyticsEvent = useSendAnalyticsEvent();

  const handleClickErrorRedirect = () => {
    window.location.href = redirect?.failureUrl;
  };

  const handleTryAgain = () => {
    window.location.href = errorRedirectUrl || `/${id}`;
  };
  const ErrorAnimationImg = getErrorAnimation(appErrorType);

  const showErrorRedirect = !appErrorType && redirect?.failureUrl;
  const showTryAgain = appErrorType === ERROR_TYPES.NO_INTERNET;

  useEffect(() => {
    setHasFooter(false);
    sendAnalyticsEvent(ANALYTICS_EVENTS.ERROR, { errorType: appErrorType });
  }, [ appErrorType, sendAnalyticsEvent, setHasFooter ]);

  return (
    <div className={styles.rootError}>
      <ErrorAnimationImg className={styles.animation} data-testid="image-error" />

      <Typography className={styles.title} variant="subtitle1" align="center" id="finish-title">
        {translate(getTranslationKeyTitles(appErrorType, 'title'))}
      </Typography>

      <Typography
        variant="body2"
        align="center"
        className={styles.greyText}
        id="finish-subtitle"
      >
        <Trans
          i18nKey={getTranslationKeyTitles(appErrorType, 'subtitle')}
          components={[ <Typography variant="body2" align="center" fontWeight="bold" /> ]}
        />
      </Typography>

      {showErrorRedirect && (
        <Button className={styles.button} onClick={handleClickErrorRedirect}>{translate('merchantRedirect.button', { merchant: name })}</Button>
      )}

      {showTryAgain && (
        <Button id="try-again-btn" onClick={handleTryAgain} className={styles.tryAgain}>{translate('finish.error.tryAgain')}</Button>
      )}

      {!appErrorType && <ContactMessage center />}
    </div>
  );
};

export default Error;
